import { render } from "./opensearch.vue?vue&type=template&id=40a5592f"
import script from "./opensearch.vue?vue&type=script&lang=js"
export * from "./opensearch.vue?vue&type=script&lang=js"

import "./opensearch.vue?vue&type=style&index=0&id=40a5592f&lang=css"

import exportComponent from "../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__